<template>
  <button
    :class="$style.root"
    @click="goToSlide(index)"
  >
    <slot />
  </button>
</template>

<script lang="ts">
export default {
  props: {
    goToSlide: Function,
    index: {
      // @https://splidejs.com/guides/apis/#go
      type: [Number, String],
      required: true
    }
  }
}
</script>

<style module>
  .root {
    composes: base--reset-button from global;
  }
</style>
